import type { User } from "@/components/AuthProvider";

export type ReleasesPageAccess = "pending" | "allowed" | "denied";

/**
 * `releases_page_enabled` describes the user's server-side active org, which
 * trails the URL org until `useOrgUrlSync` switches it and /api/user refetches.
 * Until they agree the answer is "pending", unless the URL org is one the sync
 * will never switch to (`urlOrgSelectable` false).
 */
export function releasesPageAccess({
  user,
  urlOrg,
  urlOrgSelectable,
}: {
  user: Pick<User, "active_org_name" | "releases_page_enabled"> | undefined;
  urlOrg: string | undefined;
  /** Undefined while the user's orgs are loading. */
  urlOrgSelectable: boolean | undefined;
}): ReleasesPageAccess {
  if (!user || !urlOrg) return "pending";
  const activeOrgMatches =
    user.active_org_name?.toLowerCase() === urlOrg.toLowerCase();
  if (!activeOrgMatches) {
    return urlOrgSelectable === false ? "denied" : "pending";
  }
  return user.releases_page_enabled === true ? "allowed" : "denied";
}
